export class SyncStatus {
    public static readonly SYNC_STATUS_NOT_SYNCED: number = 0;
    public static readonly SYNC_STATUS_SYNCED_IN_MEM: number = 1;
}